import PropTypes from 'prop-types';

function WordCounter({ content }) {
  const trimmed = content.trim();

  const wordCount = trimmed === '' ? 0 : trimmed.split(/\s+/).filter(Boolean).length;
  const charCount = trimmed === '' ? 0 : content.length;

  return (
    <div className="text-editor__counter">
      <span>{wordCount} {wordCount === 1 ? 'palabra' : 'palabras'}</span>
      <span>{charCount} {charCount === 1 ? 'carácter' : 'caracteres'}</span>
    </div>
  );
}

WordCounter.propTypes = {
  content: PropTypes.string.isRequired,
};

export default WordCounter;
